.oldSpecialsGrid {
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
}

@media (--reefer-media-mobile-lg-min) {
  .oldSpecialsGrid {
    display: grid;
    place-items: stretch;
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
    grid-auto-rows: min-content;
  }
}

@media (--reefer-media-desktop-sm-min) {
  .oldSpecialsGrid {
    display: grid;
    place-items: stretch;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    grid-auto-rows: min-content;
  }
}
